// extracted by mini-css-extract-plugin
export default {"monteCarloChart":"styles_monteCarloChart__bh6t5"};